import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=92b522ee&scoped=true&"
import script from "./PayResult.vue?vue&type=script&lang=js&"
export * from "./PayResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b522ee",
  null
  
)

export default component.exports